function SetWLUtmParams() {
  const currentTime = new Date();
  const UTMEndTime = new Date(currentTime.getFullYear(), currentTime.getMonth() + 1, 1);
  // get wlId from script data attributes
  const wlUtm = document.getElementById('wl-utm');
  const wlId = wlUtm.dataset.wlId;

  const url = new URL(window.location.href);
  const params = url.searchParams;

  localStorage.setItem(
    'UTMParams',
    JSON.stringify({
      timeEnd: UTMEndTime.getTime(),
      utm_source: params.get('utm_source') ? params.get('utm_source') : wlId,
      utm_medium: params.get('utm_medium') ? params.get('utm_medium') : wlId,
      utm_campaign: params.get('utm_campaign') ? params.get('utm_campaign') : wlId,
    }),
  );
}

SetWLUtmParams();
